import { GET_INFO, GET_USER, GET_TOKEN, GET_LOADERS, GET_USER_LIST, GET_QUESTIONS,GET_MANAGER_LIST_DATA,GET_BANK_AGGREGATOR_LIST, GET_IPV_RESPONSE} from '../types'
import { validObjectWithParameterKeys } from "../utils/common";
export const getters = {
  // return the latest broadcast message
  [GET_INFO] (state) {
    return state.message
  },
  // return the current user state
  [GET_USER] (state) {
    return state.user
  },
  // return the token from local storage
  //backup
  [GET_TOKEN] (state) {
    return state.user.token
  },

  // [GET_TOKEN](state) {
  //   const token =
  //     validObjectWithParameterKeys(state, ["user"]) &&
  //     validObjectWithParameterKeys(state.user, ["token"])
  //       ? state.user.token
  //       : false;
  //   return token;
  // },

  //code written by manvir

  // all loaders
  [GET_LOADERS] (state) {
    return state.loaders
  },
  [GET_BANK_AGGREGATOR_LIST] (state) {
    return state.bank_aggregator_list
  },
  [GET_QUESTIONS] (state) {
    return state.questions
  },
  [GET_IPV_RESPONSE] (state){
    return state.ipv_response;
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js